import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PCB, PCB_PRE_LAYOUT, PACKAGE } from '@/constants/treeConstants';
import PreLayout from '../preLayout';
import LayoutExplorer from '../../LayoutExplorer/Andes_v2';
import { PCB_ONLY, PCB_TOP_BOTTOM, TOP_BOTTOM_LAYOUT, PCB_LEFT_RIGHT, LEFT_RIGHT_lAYOUT } from '../../../constants/layoutConstants';
import TBLayout from '@/components/ContentLayout/topBottom';
import LRLayout from '@/components/ContentLayout/leftRight';
import { topBarResize } from '@/services/helper/topBarResize';
import projectDesigns from '@/services/helper/projectDesigns';

class PCBLayout extends Component {

  getTop = (pcbInfo) => {
    const { siderWidth } = this.props;
    switch (pcbInfo.key) {
      case PCB:
      case PACKAGE:
        return <LayoutExplorer
          designID={pcbInfo.id}
          leftWidth={siderWidth}
        />
      case PCB_PRE_LAYOUT:
        setTimeout(() => {
          this.topBarResize();
        }, 100)
        return <div id={`andes-v2-pre-layout-main-${pcbInfo.id}`} className='my-aurora-content'>
          <PreLayout designID={pcbInfo.id} leftWidth={0} />
        </div>
      default: return null;
    }
  }

  getDefault = (pcbInfo, topHeight = 0, leftWidth = 0) => {
    const { siderWidth } = this.props;
    switch (pcbInfo.key) {
      case PCB:
      case PACKAGE:
        return <LayoutExplorer
          designID={pcbInfo.id}
          leftWidth={siderWidth + leftWidth}
          topHeight={topHeight}
        />
      case PCB_PRE_LAYOUT:
        setTimeout(() => {
          this.topBarResize();
        }, 100)
        return <div id={`andes-v2-pre-layout-main-${pcbInfo.id}`} className={`my-aurora-content aurora-PCB-layout-content-${pcbInfo.id}`}>
          <PreLayout designID={pcbInfo.id} />
        </div>
      default: return null;
    }
  }

  getBottom = (pcbInfo, topHeight) => {
    return this.getDefault(pcbInfo, topHeight);
  }

  getLeft = (pcbInfo) => {
    return this.getDefault(pcbInfo);
  }

  getRight = (pcbInfo, leftWidth) => {
    return this.getDefault(pcbInfo, 0, leftWidth);
  }

  _getSplitSize = () => {
    const { selectedKeys, pcbLayout, layout } = this.props;
    let pcbs = [], includeSetup = false;
    selectedKeys.forEach(ele => {
      const arr = ele.split('-');
      if ([PCB, PCB_PRE_LAYOUT, PACKAGE].includes(arr[0])) {
        pcbs.push({ key: arr[0], id: arr[1] });
      } else {
        includeSetup = true;
      }
    });
    let count = 0;
    if (includeSetup) {
      count++;
    }
    if (!pcbs.length) {
      return count;
    } else if (pcbs.length > 1 && pcbLayout === PCB_TOP_BOTTOM && layout === TOP_BOTTOM_LAYOUT) {
      return count + 2;
    } else {
      return 2;
    }
  }

  _getLRSplitSize = () => {
    const { selectedKeys, pcbLayout, layout } = this.props;
    let pcbs = [], includeSetup = false;
    selectedKeys.forEach(ele => {
      const arr = ele.split('-');
      if ([PCB, PCB_PRE_LAYOUT, PACKAGE].includes(arr[0])) {
        pcbs.push({ key: arr[0], id: arr[1] });
      } else {
        includeSetup = true;
      }
    });
    let count = 0;
    if (includeSetup) {
      count++;
    }
    if (!pcbs.length) {
      return count;
    } else if (pcbs.length > 1 && pcbLayout === PCB_LEFT_RIGHT && layout === LEFT_RIGHT_lAYOUT) {
      return count + 2;
    } else {
      return 2;
    }
  }

  topBarResize = () => {
    topBarResize('andes-v2-prelayout-top-bar', 370);
  }

  getContent = () => {
    const { pcbLayout, selectedKeys, siderWidth, openProjectId } = this.props;
    const splitSize = this._getSplitSize();
    const lrSplitSize = this._getLRSplitSize();
    const currentProjectDesignIds = projectDesigns.getAvailableDesignIds(openProjectId) || [];

    let pcbs = [];
    selectedKeys.forEach(ele => {
      const arr = ele.split('-');
      if ([PCB, PCB_PRE_LAYOUT, PACKAGE].includes(arr[0]) && currentProjectDesignIds.includes(arr[1])) {
        pcbs.push({ key: arr[0], id: arr[1] });
      }
    });
    if (!pcbs.length) return null;
    if (pcbLayout === PCB_ONLY || pcbs.length === 1) {
      return [PCB, PACKAGE].includes(pcbs[0].key) ?
        <LayoutExplorer
          designID={pcbs[0].id}
          leftWidth={siderWidth}
        />
        : <div id={`andes-v2-pre-layout-main-${pcbs[0].id}`} className='my-aurora-content'>
          <PreLayout designID={pcbs[0].id} leftWidth={siderWidth} />
        </div>
    } else if (pcbLayout === PCB_TOP_BOTTOM) {
      return <TBLayout
        {...this.props}
        id="andes-v2-content-pcb"
        bottomClassName={"andes-v2-content-bottom"}
        getTop={() => this.getTop(pcbs[0])}
        getBottom={(topHeight) => this.getBottom(pcbs[1], topHeight)}
        splitSize={splitSize}
      />
    } else {
      return <LRLayout
        {...this.props}
        leftClassName="andes-v2-content-left"
        getLeft={() => this.getLeft(pcbs[0])}
        getRight={(leftWidth) => this.getRight(pcbs[1], leftWidth)}
        lineClassName='aurora-layout-split-screen'
        splitSize={lrSplitSize}
      />
    }
  }

  render() {
    return (
      this.getContent()
    )
  }
}

const mapState = (state) => {
  const { AndesV2Reducer } = state;
  const { project: { pcbLayout, selectedKeys, layout, openProjectId } } = AndesV2Reducer;
  const { tabVisible, monitorScreenInfo: { tabSelectKeys } } = state.MonitorInfoReducer;
  return {
    pcbLayout,
    selectedKeys,
    tabVisible,
    tabSelectKeys,
    layout,
    openProjectId
  };
}

export default connect(mapState, null)(PCBLayout);